import { Svg, Path, G } from "react-native-svg";
import { SvgProps } from "react-native-svg";

const ListIcon = (props: SvgProps) => (
  <Svg {...props} width={22} height={23} viewBox="0 0 22 23" fill="none">
    <G id="list">
      <Path
        id="Vector"
        d="M7.33333 5.93604H19.25M7.33333 11.436H19.25M7.33333 16.936H19.25M2.75 5.93604H2.75917M2.75 11.436H2.75917M2.75 16.936H2.75917"
        stroke="#090A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  </Svg>
);

export default ListIcon;
